import { Button, ButtonGroup, DrawerFooter, } from '@one-thd/sui-atomic-components';
import React from 'react';
import { usePTCDocumentsContext } from '../../../hooks/useContexts';
import { openFile } from '../../../utils/http-helper';
import { getWindow } from '../../../utils/general';
var navigateToHouseAccountPortal = function () {
    var _a, _b, _c, _d, _e, _f;
    if (typeof window !== 'undefined') {
        if (((_c = (_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.host) === null || _c === void 0 ? void 0 : _c.includes('hd-qa71')) ||
            ((_f = (_e = (_d = getWindow()) === null || _d === void 0 ? void 0 : _d.location) === null || _e === void 0 ? void 0 : _e.host) === null || _f === void 0 ? void 0 : _f.includes('hd-qa74'))) {
            window.open('https://pilotapay.bectran.com/apaymgt/regis/login.jsf?linkCode=8JDQu4871smBA2920kKyKg&gId=2920', '_blank', 'noopener,noreferrer');
        }
        else {
            window.open('https://apay.bectran.com/apaymgt/regis/login.jsf?linkCode=lwfrt2665D6LZT3530uKeap&gId=3530', '_blank', 'noopener,noreferrer');
        }
    }
};
export var PTCDocumentDrawerFooter = function () {
    var _a = usePTCDocumentsContext(), selectedDocument = _a.selectedDocument, documentLoadingError = _a.documentLoadingError, setOpenPTCDocumentDrawer = _a.setOpenPTCDocumentDrawer;
    var primaryButtonText = selectedDocument
        ? 'Download'
        : 'Trade Account Management Portal';
    var secondaryButtonText = selectedDocument
        ? 'Trade Account Management Portal'
        : 'Cancel';
    var handlePrimaryButtonClick = function () {
        if (selectedDocument && selectedDocument.blob) {
            openFile(selectedDocument.blob, selectedDocument.pdfName);
        }
        else {
            navigateToHouseAccountPortal();
        }
    };
    var handleSecondaryButtonClick = function () {
        if (selectedDocument) {
            navigateToHouseAccountPortal();
        }
        else {
            setOpenPTCDocumentDrawer(false);
        }
    };
    return (React.createElement(DrawerFooter, null,
        React.createElement("div", { className: "sui-flex sui-gap-2 sui-w-full" },
            React.createElement(ButtonGroup, { orientation: "vertical", variant: "secondary", fullWidth: true },
                React.createElement(Button, { fullWidth: true, variant: "primary", onClick: function () { return handlePrimaryButtonClick(); }, disabled: selectedDocument && documentLoadingError }, primaryButtonText),
                React.createElement(Button, { fullWidth: true, variant: "secondary", onClick: function () { return handleSecondaryButtonClick(); } }, secondaryButtonText)))));
};
